import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/core/analytics/")({
  beforeLoad: () => {
    throw redirect({ to: "/core/analytics/project-data", replace: true })
  }
})
